import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  ContainerType,
  CreateContainerTypeRequest,
  UpdateContainerTypeRequest,
  ContainerTypesListParams
} from '../types';

const { CONTAINER_TYPES } = API_ENDPOINTS;

export const containerTypesApi = {
  getAll: (params?: ContainerTypesListParams) =>
    apiClient.getPaginated<ContainerType>(CONTAINER_TYPES.LIST, params),

  getById: (id: number) =>
    apiClient.get<ContainerType>(CONTAINER_TYPES.GET(id)),

  create: (data: CreateContainerTypeRequest) =>
    apiClient.post<ContainerType>(CONTAINER_TYPES.CREATE, data),

  update: (id: number, data: UpdateContainerTypeRequest) =>
    apiClient.put<ContainerType>(CONTAINER_TYPES.UPDATE(id), data),

  delete: ({ id, force }: { id: number; force?: boolean }) =>
    apiClient.delete(CONTAINER_TYPES.DELETE(id) + (force ? '?force=true' : '')),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<ContainerTypesListParams> }
  ) => apiClient.post(CONTAINER_TYPES.BULK_DELETE, params),

  bulkChangeStatus: (
    params:
      | { ids: number[]; status: 'active' | 'inactive' }
      | {
          all: true;
          filters: Partial<ContainerTypesListParams>;
          status: 'active' | 'inactive';
        }
  ) => apiClient.post(CONTAINER_TYPES.BULK_CHANGE_STATUS, params)
};
